import {gql} from "@apollo/client";

export const MALFUNCTIONS_QUERY = gql`
    query ExampleQuery {
        Alerts {
            routeNode
            type
            status
            spaceConnection
            date
            levels
            location
            station
        }
    }
`;